<template>
  <section id="confirmation">
    <div class="container print" v-if="confirmation">
      <div class="content">
        <div class="title no-display">
            <img alt="OpenCabana" src="https://api.opencabana.com/images/logo.png" class="inline-text"> <span>OpenCabana</span>
        </div>

        <div class="header no-display">
          Reservation Confirmation
        </div>

        <div class="body">
          <!-- PRINT THIS, BUT DONT DISPLAY -->
          <div class="no-display">
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-8">
                    <h3 v-html="confirmation.location_name"></h3>
                  </div>
                  <div class="col-4" style="text-align: right">
                    Date: <span v-if="confirmation.last_updated_at" v-html="confirmation.last_updated_at"></span>
                  </div>
                </div>
                <p v-if="confirmation.location_address" v-html="confirmation.location_address"></p>
                <p v-if="confirmation.booking_no" v-html="'Bookind ID: #' + confirmation.booking_no"></p>
                <p v-if="confirmation.reserved_from_display && confirmation.reserved_to_display" v-html="confirmation.reserved_from_display + ' - ' + confirmation.reserved_to_display"></p>
              </div><!-- end .col-12 -->
            </div><!-- end .row -->

            <div class="row">
              <div class="col-12">
                <table width="100%" class="booking-table">
                  <tr>
                    <th width="50%">
                      Description
                    </th>
                    <th width="25%">
                      <!-- Qty -->
                    </th>
                    <th width="25%">
                      Amount
                    </th>
                  </tr>

                  <!-- <tr v-if="confirmation.seat_display">
                    <td>
                      <div class="product-title">
                        Seats
                      </div>
                      <span v-html="confirmation.seat_display"></span>
                    </td>
                    <td>
                      {{ confirmation.total_seats }}
                    </td>
                    <td v-html="confirmation.seat_amount_display">
                    </td>
                  </tr> -->

                  <tr v-if="confirmation.seat_dates">
                    <td colspan="3">
                      <!-- <div class="product-title">
                        Seats
                      </div> -->
                      <table width="100%" class="booking-table-inner">
                        <tr v-for="seat_date in confirmation.seat_dates">
                          <td width="50%" style="padding-left: 0px">
                            <span v-html="seat_date.seat_display"></span> -
                            <span v-html="seat_date.from_date"></span>
                          </td>
                          <td width="25%">
                            <!-- {{ seat_date.total_seats }} -->
                          </td>
                          <td width="25%" v-html="seat_date.seat_amount_display">
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>

                  <tr v-if="confirmation.food_package">
                    <td>
                      <div class="product-title">
                        Food
                      </div>
                      <span v-html="confirmation.food_package"></span>
                      <div class="product-desc" v-html="confirmation.food_package_desc">
                      </div>
                    </td>
                    <td>
                    </td>
                    <td v-html="confirmation.food_package_amount_disp">
                    </td>
                  </tr>

                  <tr v-if="confirmation.tax_amount_display">
                    <td>
                    </td>
                    <td>
                      <strong>Tax</strong>
                    </td>
                    <td v-html="confirmation.tax_amount_display">
                    </td>
                  </tr>

                  <tr v-if="confirmation.service_fee_amount_display">
                    <td>
                    </td>
                    <td>
                      <strong>Service Fee</strong>
                    </td>
                    <td v-html="confirmation.service_fee_amount_display">
                    </td>
                  </tr>

                  <!-- <tr v-if="confirmation.discount_amount_display">
                    <td>
                    </td>
                    <td>
                      <strong>Discount</strong>
                    </td>
                    <td v-html="confirmation.discount_amount_display">
                    </td>
                  </tr> -->

                  <tr v-if="confirmation.total_amount_display">
                    <td>
                    </td>
                    <td>
                      <strong>Total</strong>
                    </td>
                    <td v-html="confirmation.total_amount_display">
                    </td>
                  </tr>

                  <!-- <tr v-if="confirmation.deposit_amount_display">
                    <td>
                    </td>
                    <td>
                      <strong>Deposit</strong>
                    </td>
                    <td v-html="confirmation.deposit_amount_display">
                    </td>
                  </tr> -->

                  <!-- <tr v-if="confirmation.due_amount_display">
                    <td>
                    </td>
                    <td>
                      <strong>Due</strong>
                    </td>
                    <td>
                      {{ confirmation.due_amount_display }}
                    </td>
                  </tr> -->
                </table><br><br>

                <div class="terms no-display" v-if="confirmation.location_terms">
                  <span v-html="confirmation.location_terms"></span>
                </div>

                <div class="desc no-display" v-if="confirmation.location_description">
                  <span v-html="confirmation.location_description"></span>
                </div>
              </div><!-- end .col-12 -->
            </div><!-- end .row -->
          </div>

          <!-- DISPLAY, BUT DONT PRINT -->
          <div class="no-print text-big text-center">
            Your reservation has been submitted.<br><br>

            You will receive an email and a text with your reservation details <span  v-if="confirmation.email">at {{ confirmation.email }}</span>.<br><br>
          </div>
        </div><!-- .body -->
      </div>

      <div class="row no-print">
        <div class="col-12 text-right">
          <a class="btn el-button btn-primary mt-5" @click="doPrint()" href="javascript:;">Print Receipt</a>

          <a class="btn  el-button  btn-success mt-5" v-if="!isLoggedIn"  href="#/home">Done</a>

          <a class="btn el-button  btn-primary mt-5" v-if="isLoggedIn" href="#/dashboard">Done</a>
        </div><!-- end .col-12 -->
      </div><!-- end .row -->
    </div><!-- end .container -->
  </section>
</template>

<script>
import { getConfirmation } from '@/api/reservation'
export default {
  name: 'ReservationConfirmation',
  data() {
    return {
      reservationId: '',
      paidStatus: false,
      confirmation: ''
    }
  },
  created() {
    this.reservationId = this.$route.params.id
    getConfirmation(this.reservationId).then(response => {
      if (response.data.success == true) {
        this.confirmation = response.data.data[0]
        this.paidStatus = this.confirmation.paid_status
      }
      this.loading = false
    })
  },
  methods: {
    doPrint() {
      window.print()
    }
  }
}
</script>
<style lang="scss"  scoped>
.text-big{
  @media only screen and(max-width:500px) {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// confirmation.vue?2ece0eb6